type Option = {
  label: string;
  value: string | number;
};

export const organizationOptions: Readonly<Option[]> = [
  {
    label: '県立高等学校',
    value: 1,
  },
  {
    label: '県立中等教育学校',
    value: 2,
  },
] as const;
